export const environment = {
  production: false,
  brands: {
    enelx: {
      globalNavUrl: 'https://global-nav-v2.preprd-svcs.enernoc.net/api/v2',
    },
  },
  cdn: 'https://cdn.preprd-apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
